import { render, staticRenderFns } from "./auth-list.vue?vue&type=template&id=56a1dbf1&scoped=true&"
import script from "./auth-list.vue?vue&type=script&lang=js&"
export * from "./auth-list.vue?vue&type=script&lang=js&"
import style0 from "./auth-list.vue?vue&type=style&index=0&id=56a1dbf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a1dbf1",
  null
  
)

export default component.exports